<div class="select-tenant-container">
    <div class="form-container">
      <div class="container-logo">
        <img class="login-logo" src="assets/logos/logo-agenda-group-7479.svg" />
      </div>
      <div class="text-center">
        <p>Selecione uma escola para continuar</p>
      </div>
      <div class="tenants-list-container" *ngIf="identities.length > 0 && !loading && !shouldSelectSchool">
        <button class="tenant-button" mat-raised-button *ngFor="let identity of identities"
          [disabled]="loading"
          (click)="selectIdentity(identity)">
          {{ identity.tenant }}
        </button>
      </div>
      <div class="schools-list-container" *ngIf="shouldSelectSchool">
        <button class="school-button" mat-raised-button *ngFor="let school of schools"
          [disabled]="loading"
          (click)="selectSchool(school)">
          {{ school.name }}
        </button>
      </div>
      <mat-progress-bar *ngIf="loading" mode="indeterminate" class="effect-mid mat-loading"></mat-progress-bar>
    </div>
</div>